/**
 * Created by Christof Sander on 01.07.2016.
 */

module.exports = {
	config: {
		delimiter: ' / ',
		// separatedFieldCodes: {
		// 	year: "real fieldName of year",
		// 	month: "real fieldName of month"
		// }
	},

	model: {
		value: ''
	},

	events: {
		beforeChange: {
			type: 'input',
			action: function(event){
				var self = event.data.component;
				var originalValue = this.value;
				if(self.updateValue(originalValue)){
					this.selectionEnd = self.format(originalValue, this.selectionStart, this.selectionEnd);
				}
			}
		},
		onChange: {
			type: 'change',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				self.updateValue(self.$.val());

				var value = self.model.splitValue || {};
				self.triggerClosest('onChildChanged', {
					fieldCode: 	self.model.fieldCode,
					value: 		value
				});
			}
		}
	},

	methods: {
		prepare: function(){
			this.model.disabled = false;
			this.model.isFilterField = false;
			if((this.formMapping || {}).fieldConfig) {
				this.model.disabled = this.formMapping.fieldConfig.disabled;
				this.model.isFilterField = this.formMapping.fieldConfig.isFilterField;
			}

			this.model.config = this.model.config || {};
			this.model.disabled |= this.model.config.disabled;

			this.model.dataFlag = 'dataTEXT';
			if(this.model.atom.dataType === 'integer'){
				this.model.dataFlag = 'dataINT';
			}

			this.model.delimiterLength = String(this.config.delimiter).length || 0;
			this.model.maxCleanLength = 6;
			var patternPartMonth = '(\\d{0,2})';
			var patternPartYear = '(\\d{0,4})';
			this.model.pattern = new RegExp(patternPartMonth + patternPartYear + '(.*)');

			var newValue;
			if(this.model.isFilterField){
				newValue = this.model.filterValue;
			} else {
				newValue = this.model[this.model.dataFlag];
			}
			this.updateValue(newValue);
		},

		updateValue: function(value){
			var splitValue = String(value).split(this.config.delimiter);
			var splitValue = {
				month: 	splitValue[0],
				year: 	splitValue[1]
			}
			var newValue = String(value).replace(/\D/g, '');
			if(newValue !== this.model.value || String(value).length !== this.model.value.length){
				this.model.value = newValue;
				this.model.splitValue = splitValue;
				return true;
			}

			return false;
		},

		format: function(originalValue, selectionStart, selectionEnd){
			// init
			selectionStart = parseInt(selectionStart);
			selectionEnd = parseInt(selectionEnd);
			originalValue = originalValue || '';
			var newSelection = selectionEnd;

			// calculate and return new cursor position
			if(selectionStart == selectionEnd){
				selectionStart -= (originalValue.substring(0, selectionStart).match(/\D/g) || []).length || 0;

				newSelection = selectionStart;
				if(selectionStart > 2) newSelection += this.model.delimiterLength;

				if(this.model.value.length > this.model.maxCleanLength && selectionStart < (this.model.maxCleanLength - 1)) {
					this.updateValue(this.model.value.substring(0, selectionStart) + this.model.value.substring(selectionStart + this.model.value.length - this.model.maxCleanLength));
				}
			}

			// set new value
			var replacement = '', n;
			for(n = 0; n < 2; n++){
				if(n > 0) replacement += this.config.delimiter;
				replacement += '$' + (n + 1);
			}
			var newValue = this.model.value.replace(this.model.pattern, replacement);
			this.$.val(newValue);

			return newSelection;
		}
	},

	hooks: {
		attach: function($element, options){
			if(!options.refresh){
				var initValue = this.model.dataJSON || {};
				if(initValue.month || initValue.year){
					this.model.value = String(initValue.month).padStart(2, '0') + String(initValue.year).padStart(4, '0');
				}
				if(this.model.value){
					this.format();
				}
			}
		}
	}
};
